import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import thresholds from '../data/sepsisThresholds.json';

interface RiskFactorsModalProps {
  open: boolean;
  onClose: () => void;
}

const RiskFactorsModal: React.FC<RiskFactorsModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      dir="rtl"
      maxWidth="sm"
      fullWidth
      PaperProps={{ 'data-testid': 'sepsis-risk-modal' } as any}
    >
      <DialogTitle
        sx={{
          backgroundColor: '#fff7ed',
          color: '#92400e',
          fontWeight: 700,
          fontSize: '1.3rem',
          textAlign: 'center',
          borderBottom: '2px solid #fed7aa',
        }}
      >
        גורמי סיכון רפואיים
      </DialogTitle>
      <DialogContent sx={{ paddingTop: '1rem !important' }}>
        <p
          style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            marginBottom: '1rem',
            textAlign: 'right',
          }}
        >
          לחץ על הכפתור אם המטופל סובל מאחד או יותר מהבאים:
        </p>
        <ul
          style={{
            paddingRight: '1.25rem',
            paddingLeft: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          {thresholds.riskFactors.map((factor) => (
            <li
              key={factor}
              style={{
                fontSize: '0.95rem',
                color: '#374151',
                lineHeight: 1.5,
                textAlign: 'right',
              }}
            >
              {factor}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem', justifyContent: 'center' }}>
        <Button
          variant="contained"
          onClick={onClose}
          data-testid="sepsis-risk-modal-close"
          sx={{
            backgroundColor: '#d97706',
            fontWeight: 700,
            fontSize: '1rem',
            minWidth: 120,
            '&:hover': { backgroundColor: '#b45309' },
          }}
        >
          סגור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RiskFactorsModal;
